import { inject } from '@angular/core';
import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';

import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthService } from 'src/app/services/auth.service';

/**
 * Clears the session on a 401/403 so an expired/revoked token doesn't leave the app in a
 * half-authenticated state — the next guarded navigation then re-triggers login.
 * @param req
 * @param next
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
	const authService = inject(AuthService);
	return next(req).pipe(
		catchError((error: unknown) => {
			if (error instanceof HttpErrorResponse && (error.status === 401 || error.status === 403)) {
				console.log('[authInterceptor] 401/403 detected, clearing session');
				authService.clearSession();
			}
			return throwError(() => error);
		}),
	);
};
